import React from 'react';

/**
 * lot DJ3 — référence du bien d'une notification : UN SEUL affichage pour la page et l'aperçu.
 * Cliquer la référence ouvre la fiche du bien (`onOuvrir` marque la notification comme lue).
 */
export const ReferenceBien = ({ ligne, onOuvrir, prefixeTest = 'notification' }) => {
  if (!ligne.property_reference) return null;
  return (
    <p className="text-xs mt-0.5 break-words">
      <button
        type="button"
        onClick={() => onOuvrir(ligne, `/properties/${ligne.property_id}/view`)}
        data-testid={`${prefixeTest}-bien-${ligne.id}`}
        className="num font-semibold text-blue-600 hover:underline"
      >
        {ligne.property_reference}
      </button>
      {(ligne.biens_supplementaires || []).map((reference) => (
        <span key={reference} className="num text-slate-500"> · {reference}</span>
      ))}
      {ligne.property_libelle && (
        <span className="text-slate-500"> — {ligne.property_libelle}</span>
      )}
    </p>
  );
};

export default ReferenceBien;
